import { FC, useState } from "react";
import "./CSS/KeysDetailScreen.css";
import backIcon from "../../assets/images/back-icon.svg";
import { useNavigate } from "react-router-dom";
import KeysExpandableSection from "./Views/KeysExpandableSection";
import { useStorage } from "services/StorageProvider";

const KeysDetailScreen: FC = () => {
  const navigate = useNavigate();
  const { userProfileData } = useStorage();
  const [innovativeCopyStatus, setInnovativeCopyStatus] = useState("");
  const [communicateCopyStatus, setCommunicateCopyStatus] = useState("");
  const [memberCopyStatus, setMemberCopyStatus] = useState("");
  const [cleanFuelCopyStatus, setCleanFuelCopyStatus] = useState("");

  const copyPassword = async (copyCode: any, copyStatus: any) => {
    try {
      await navigator.clipboard.writeText(copyCode);
      copyStatus("Copied!");
      setTimeout(() => copyStatus(""), 6000);
    } catch (err) {
      copyStatus("Failed to copy");
    }
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="wms-mobile-container">
      <div className="keys-detail-screen-container">
        <div className="keys-detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">UR Keys</div>
        </div>
        <KeysExpandableSection title="UR Deep Focus WorkSpace Door Key">
          <div className="item-container">
            <span>
              <strong>1 4 8 9 0 0 #</strong>
            </span>
          </div>
        </KeysExpandableSection>
        {userProfileData?.credit?.member_cafe_coupon_code && (
          <KeysExpandableSection title="TF Member Cafe Coupon Code">
            <div className="item-container">
              <span>
                <strong>
                  {userProfileData?.credit?.member_cafe_coupon_code}
                </strong>
                <button
                  onClick={() =>
                    copyPassword(
                      userProfileData?.credit?.member_cafe_coupon_code,
                      setMemberCopyStatus,
                    )
                  }
                >
                  {memberCopyStatus ? "Copied!" : "Copy"}
                </button>
              </span>
            </div>
          </KeysExpandableSection>
        )}
        {userProfileData?.credit?.clean_fuel_cafe_coupon_code && (
          <KeysExpandableSection title="UR Clean Fuel Café Coupon">
            <div className="item-container">
              <span>
                <strong>
                  {userProfileData?.credit?.clean_fuel_cafe_coupon_code}
                </strong>
                <button
                  onClick={() =>
                    copyPassword(
                      userProfileData?.credit?.clean_fuel_cafe_coupon_code,
                      setCleanFuelCopyStatus,
                    )
                  }
                >
                  {cleanFuelCopyStatus ? "Copied!" : "Copy"}
                </button>
              </span>
            </div>
          </KeysExpandableSection>
        )}
        <KeysExpandableSection title="UR Innovative Space Wi-Fi">
          <div className="item-container">
            <span>
              <strong>Wi-Fi Name:-</strong> SabeHub - Innovative Space
              <br />
              <strong>Wi-Fi Password:-</strong> Sabe08@#Inno98vate{" "}
              <button
                onClick={() =>
                  copyPassword("Sabe08@#Inno98vate", setInnovativeCopyStatus)
                }
              >
                {innovativeCopyStatus ? "Copied!" : "Copy"}
              </button>
            </span>
          </div>
        </KeysExpandableSection>
        <KeysExpandableSection title="UR Communicate Space Wi-Fi">
          <div className="item-container">
            <span>
              <strong>Wi-Fi Name:-</strong> SabeHub: Communicate Space
              <br />
              <strong>Wi-Fi Password:-</strong> SabeCSB2526B@55#5E{" "}
              <button
                onClick={() =>
                  copyPassword("SabeCSB2526B@55#5E", setCommunicateCopyStatus)
                }
              >
                {communicateCopyStatus ? "Copied!" : "Copy"}
              </button>
            </span>
          </div>
        </KeysExpandableSection>
      </div>
    </div>
  );
};

export default KeysDetailScreen;
